import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { DialogService } from '../../../services/dialog/dialog.service';

@Component({
  selector: 'psc-info-icon',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './info-icon.component.html',
  styleUrls: ['./info-icon.component.scss'],
})
export class InfoIconComponent {

  @Input() sizeInPx: number;
  @Input() iconColorClass: string = 'text-color-blue2';
  @Input() infoText: string | undefined;

  constructor(
    private dialogService: DialogService,
  ) {
  }

  openInfoDialog() {
    if (this.infoText) {
      this.dialogService.openInfoDialog(this.infoText);
    }
  }
}
